import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { CaretDoubleLeft, CaretDoubleRight, List } from "@phosphor-icons/react";
import { useState } from "react";
export const Toggle = ({ onClick, open }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (_jsxs(Button, { onClick: onClick, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), variant: "ghost", className: css({
            color: "white",
            width: 12,
            height: 12,
            transition: "all 0.3s ease",
            "&:hover": {
                opacity: 0.8,
                backgroundColor: "primary",
            },
        }), children: [isHovered && !open && _jsx(CaretDoubleRight, { size: 37 }), isHovered && open && _jsx(CaretDoubleLeft, { size: 37 }), !isHovered && _jsx(List, { size: 37 })] }));
};
//# sourceMappingURL=Toggle.js.map